// extracted by mini-css-extract-plugin
export default {"welcomeSection":"KarieraWelcome_welcomeSection__U6kGD","text":"KarieraWelcome_text__MsTT7","textPhone":"KarieraWelcome_textPhone__EzMDB"};